import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const ProfileGet = createAsyncThunk(
    '/ProfileGet',
    async (data) => {
        let url = baseUrl+'ProfileGet';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  export const CompanyLogo = createAsyncThunk(
    '/CompanyLogo',
    async (data) => {
        let url = baseUrl+'CompanyLogo';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const CompanyBanner = createAsyncThunk(
    '/CompanyBanner',
    async (data) => {
        let url = baseUrl+'CompanyBanner';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );
 
  export const SocialUpdate = createAsyncThunk(
    '/SocialUpdate',
    async (data) => {
        let url = baseUrl+'SocialUpdate';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const IntroUpdate = createAsyncThunk(
    '/IntroUpdate',
    async (data) => {
        let url = baseUrl+'introUpdate';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data


        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const AddBranch = createAsyncThunk(
    '/addBranch',
    async(data) => {
      let url = baseUrl + 'addBranch';
      const token=Cookies.get("token");
      try{
        const response = (await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      }catch(err){
        return Promise.reject(err)
      }
    }
  )

  export const UpdateBranch = createAsyncThunk(
    '/updateBranch',
    async(data) => {
      let url = baseUrl + 'updateBranch';
      const token=Cookies.get("token");
      try{
        const response = (await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      }catch(err){
        return Promise.reject(err)
      }
    }
  )

  export const DeleteBranch = createAsyncThunk(
    '/deleteBranch',
    async(data) => {
      let url = baseUrl + 'deleteBranch';
      const token=Cookies.get("token");
      try{
        const response = (await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      }catch(err){
        return Promise.reject(err)
      }
    }
  )

  export const GetBranches = createAsyncThunk(
    '/getBranches',
    async(data) => {
      let url = baseUrl + 'getBranches';
      const token=Cookies.get("token");
      try{
        const response = (await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        })).data

        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      }catch(err){
        return Promise.reject(err)
      }
    }
  )



  


  